export enum CHECKTYPE {
  PRELOADCHECKS,
  ANNUALVETTINGS,
}